import React from 'react';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Modal, ProjectPreview } from 'components';
import { motion, AnimatePresence } from 'framer-motion';

const CarouselImage = ({ image, alt, id, disableModal }) => {
  return (
    <>
      <AnimatePresence exitBeforeEnter>
        <ClickableImage
          key={id}
          initial={{ opacity: 0, zIndex: 0 }}
          animate={{ opacity: 1, zIndex: 1 }}
          exit={{ opacity: 0, zIndex: 0 }}>
          <Modal
            disableModal={disableModal}
            trigger={<GatsbyImage image={image} alt={alt} />}
            modalContent={<ProjectPreview startPoint={id} />}
          />
        </ClickableImage>
      </AnimatePresence>
    </>
  );
};

const ClickableImage = styled(motion.div)`
  position: relative;
  :nth-child(2) {
    grid-column: 2/5;
  }
  :nth-child(3) {
    grid-column: 5/9;
  }
  :nth-child(4) {
    grid-column: 9/12;
  }
`;

export default CarouselImage;
